import { consumerPostSubmissionApprovedEpics } from '../modules/consumer-post-submission-approved/store/consumer-post-submission-approved.epics'
import { ConsumerPostSubmissionOffersEpics } from '../modules/consumer-post-submission-offers/store/consumer-post-submission-offers.epics'

export const consumerPostSubmissionEpics = [
  ...consumerPostSubmissionApprovedEpics,
  ...ConsumerPostSubmissionOffersEpics
]
